import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { ContemporaryLandingHeroMakerRowItem } from './ContemporaryLandingHeroMakerRowItem';

import styles from './ContemporaryLandingHeroMakerRow.scss';

export const ContemporaryLandingHeroMakerRow = ({ heroMakerRow }) => {
    if (!heroMakerRow || !heroMakerRow.items) {
        return null;
    }

    return (
        <div className={`rowFlex ${styles.wrapper}`}>
            {heroMakerRow.items.map((item, index) => (
                <ContemporaryLandingHeroMakerRowItem key={`${item.name}-${index}`} item={item} />
            ))}
        </div>
    );
};

ContemporaryLandingHeroMakerRow.propTypes = {
    heroMakerRow: PropTypes.object,
};
